module.exports = __webpack_public_path__ + "img/eye-svgrepo-com.3fa9e645.svg";